import Resource from '@/api/core/resource'

class Combo extends Resource {
  constructor () {
    super('combos')
  }

  listado (filtros) {
    return this.request.post(this.uri, filtros)
  }
}

export default new Combo()
